export default __webpack_public_path__ + "static/media/FrozenABC2_05.b6683175.png";